import PropTypes from 'prop-types';

const ListPageHeaderLayout = ({ children }) => <div className="pb-4 flex flex-col">{children}</div>;

ListPageHeaderLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
};
export default ListPageHeaderLayout;
